// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1UmPi","Label":"BuildControl_Label__2C0ga","Less":"BuildControl_Less__1SFYR","More":"BuildControl_More__1bjKz"};